import { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema, toTypedRxJsonSchema } from 'rxdb';

import { pendingReviewSchemaProperty } from './pending-review';

const blockSchemaLiteral = {
  title: 'block schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 50,
      type: 'string',
    },
    userId: { type: 'string' },

    content: { type: 'string' },
    name: { type: 'string' },

    instructions: {
      type: 'object',
      // map of instruction.id to enabled boolean
      additionalProperties: { type: 'boolean' },
    },
    aliases: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    tagIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    pendingReview: pendingReviewSchemaProperty,

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    archivedAt: { type: ['string', 'null'] },
    archived: { type: 'boolean' },
  },
  required: ['id', 'userId', 'content', 'name', 'aliases', 'tagIds', 'createdAt', 'updatedAt', 'archived'],
  indexes: [['archived']],
} as const;
const _blockSchemaTyped = toTypedRxJsonSchema(blockSchemaLiteral);

export type Block = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _blockSchemaTyped>;
export const blockSchema: RxJsonSchema<Block> = blockSchemaLiteral;
